import {
  Alert,
  Button, notification,
  Select,
} from 'antd';
import React, { useState } from 'react';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Helpers from '@Apis/helpers';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3DateSelector from '@Uilib/h3DateSelector';
import CategoryFilterNew from '@Components/Common/CategoryFilterNew';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import ReportActions from '@Actions/reportActions';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import PRZSelect from '../../Common/UI/PRZSelect';

const { Option } = Select;

const ReportForm = ({
  user,getDownloadReports, getDownloadReportsLoading, title, firstSubUrl, secondSubUrl, type,
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedInterval, setSelectedInterval] = useState('this_month');
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState(dayjs().startOf('month').valueOf());
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState(dayjs().endOf('month').valueOf());
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState([user?.tenant_info?.tenant_id]);
  const [selectedMethod, setSelectedMethod] = useState('avg_landed_cost_price');
  const [selectedEmails, setSelectedEmails] = useState([user.username]);

  const updateDate = (startDate, endDate) => {
    setStartDateMomentEpoch(startDate);
    setEndDateMomentEpoch(endDate);
  };

  const handleDateChange = (value) => {
    setSelectedInterval(value);
    if (value === 'today') {
      updateDate(dayjs().utc().startOf('day').valueOf(), dayjs().utc().endOf('day').valueOf());
    }
    if (value === 'yesterday') {
      updateDate(dayjs().utc().subtract(1, 'days').startOf('day')
        .valueOf(), dayjs().utc().subtract(1, 'days').endOf('day')
        .valueOf());
    }
    if (value === 'this_week') {
      updateDate(dayjs().utc().startOf('week').valueOf(), dayjs().utc().endOf('week').valueOf());
    }
    if (value === 'last_week') {
      updateDate(dayjs().utc().subtract(1, 'weeks').startOf('week')
        .valueOf(), dayjs().utc().subtract(1, 'weeks').endOf('week')
        .valueOf());
    }
    if (value === 'this_month') {
      updateDate(dayjs().utc().startOf('month').valueOf(), dayjs().utc().endOf('month').valueOf());
    }
    if (value === 'last_month') {
      updateDate(dayjs().utc().subtract(1, 'months').startOf('month')
        .valueOf(), dayjs().utc().subtract(1, 'months').endOf('month')
        .valueOf());
    }
    if (value === 'this_quarter') {
      updateDate(dayjs().utc().quarter(dayjs().utc().quarter()).startOf('quarter')
        .valueOf(), dayjs().utc().endOf('quarter').valueOf());
    }
    if (value === 'last_quarter') {
      updateDate(dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
        .startOf('quarter')
        .valueOf(), dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
        .endOf('quarter')
        .valueOf());
    }
    if (value === 'this_year') {
      updateDate(dayjs().utc().startOf('years').valueOf(), dayjs().utc().endOf('years').valueOf());
    }
    if (value === 'last_year') {
      updateDate(dayjs().utc().subtract(1, 'years').startOf('years')
        .valueOf(), dayjs().utc().subtract(1, 'years').endOf('years')
        .valueOf());
    }
    if (value === 'customize') {
      setStartDateMomentEpoch(null);
      setEndDateMomentEpoch(null);
    }
  };

  const loadReportsDownloadData = (operationType, required) => {
    setFormSubmitted(true)
    // firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails
    if (!getDownloadReportsLoading && selectedTenant?.length >= 1 && selectedEmails?.length >= 1) {
      getDownloadReports(firstSubUrl, secondSubUrl, user?.tenant_info?.org_id, selectedTenant || user?.tenant_info?.tenant_id, startDateMomentEpoch, endDateMomentEpoch, operationType, type, '', selectedDepartment, '', '', selectedEmails.join(','), required, '', '', '', '', selectedMethod, '', selectedCategory, () => {
        setFormSubmitted(false);
      });
    } else {
      notification.open({
        type: 'error',
        message: 'Please provide all mandatory filters.',
        placement: 'top',
        duration: 5,
      })
    }
  }

  return (
    <div className="report-form__wrapper">
      <H3Text text={title} className="report-form__title" />
      <div className="ant-row">
        <div className="ant-col-md-12">
          <H3Text text="Date Range" className="report-form__label" />
          <H3DateSelector
            selectedInterval={selectedInterval}
            onListChange={(value) => handleDateChange(value)}
            startDate={startDateMomentEpoch}
            endDate={endDateMomentEpoch}
            onDateChange={(date) => {
              setStartDateMomentEpoch(dayjs(date[0])?.valueOf());
              setEndDateMomentEpoch(dayjs(date[1])?.endOf('day')?.valueOf());
              setSelectedInterval('customize');
            }}
            disabled={getDownloadReportsLoading}
          />
        </div>
        <div className="ant-col-md-12">
          <H3Text text="Product Category" className="report-form__label" />
          <CategoryFilterNew
            onChange={(value) => {
              setSelectedCategory(value);
            }}
            selectedCategory={selectedCategory}
            hideTitle
            placeholder="Select category.."
          />
        </div>
        <div className="ant-col-md-12">
          <H3Text text="Location" className="report-form__label" />
          <TenantSelector
            selectedTenant={selectedTenant}
            showSearch
            noDropdownAlign
            onChange={(value) => {
              setSelectedTenant(value);
            }}
            placeholder="Select Business Unit"
            isMultiple
            hideTitle
            showError={formSubmitted && selectedTenant?.length < 1}
            includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)}
          />
        </div>
        <div className="ant-col-md-12">
          <H3Text text="Department" className="report-form__label" />
          <SelectDepartment
            title="Department"
            hideTitle
            selectedDepartment={selectedDepartment}
            noDropdownAlign
            onChange={(value) => {
              setSelectedDepartment(value);
            }}
            isMultiple
            emptyNotAllowed
            showSearch
            disabled={getDownloadReportsLoading || (user?.tenant_info?.inventory_config?.settings?.department_wise_visibility && Number(user?.tenant_info?.default_store_id) !== Number(Helpers.getTenantDepartmentId(user)))}
          />
        </div>
        <div className="ant-col-md-12">
          <H3Text text="Costing Method" className="report-form__label" />
          <PRZSelect
            disabled={getDownloadReportsLoading}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            value={selectedMethod}
            onChange={(value) => {
              setSelectedMethod(value);
            }}
            placeholder="Select Costing Method"
            loading={getDownloadReportsLoading}
            options={priceOptions}
          />
        </div>
        <div className="ant-col-md-12">
          <H3Text text="Your Email Address" className="report-form__label" />
          <PRZSelect
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            mode="tags"
            filterOption={false}
            value={selectedEmails}
            onChange={(value) => setSelectedEmails(value)}
            placeholder="Enter email address"
            disabled={getDownloadReportsLoading}
            maxTagCount="responsive"
            showError={formSubmitted && selectedEmails?.length < 1}
            errorName="*Please enter email address"
            errorClassName="input-error"
          >
            {selectedEmails.length > 0 ? (
              selectedEmails.map((item) => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))
            ) : (
              <Option key={user?.email} value={user?.email}>
                {user?.email}
              </Option>
            )}
          </PRZSelect>
        </div>
        <div className="ant-col-md-24">
          <Alert type="info" message="The report will be sent to you over email. This may take 3-5 minutes." showIcon />
          <Button type="primary" style={{ marginTop: '30px' }} loading={getDownloadReportsLoading} onClick={() => loadReportsDownloadData('send_email', true)}>
            Download Report
          </Button>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = ({
  UserReducers, ReportReducers,
}) => ({
  user: UserReducers.user,
  getDownloadReportsLoading: ReportReducers.getDownloadReportsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getDownloadReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category, callback) => dispatch(
    ReportActions.getDownloadReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category, callback),
  ),
});

ReportForm.propTypes = {
  history: PropTypes.func,
  title: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportForm));
